import { Component, OnInit, ViewChild, Inject, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { HostListener } from '@angular/core';
import { MatTable } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
// import { SuppInvSearchSubitemComponent } from '../supp-inv-search-subitem/supp-inv-search-subitem.component';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';
import { InvoiceItemCommentComponent } from '../invoice-item-comment/invoice-item-comment.component';

@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.css']
})
export class InvoiceItemComponent implements OnInit, OnChanges {

  // @Input('dp') dp: any;
  // @Input('parent_name') parent_name: string;
  @Input('model') model: any;
  @Input('data_model') data_model: any;
  @Input('invoice_item') invoice_item: any;
  @Input('toDelete') toDelete: any;

  @Output() dpList = new EventEmitter<object>();

  search_obj = {
    'placeholder': 'اسم الصنف', 'class_name': 'smallField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `sub_item`.`is_sale` = '1'"
    }]
  };

  sub_item_search = {
    'placeholder': 'اسم الصنف/ Item Name', 'class_name': 'longField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': " AND `main_item`.`main_item_id` = `sub_item`.`main_item_id` AND `sub_item`.`is_sale` = '1'"
    }]
  };

  inv_model = {
    'avail_amount': '', 'unit_no': '', 'count': '', 'price': '', 'discount': '', 'net_price': '',
    'location': '', 'serial': '', 'sub_item_no': '', 'sub_item_number': '', 'tax_no': '0', 'total_price': '',
    'tax_amount': '', 'min_sale_qty': '', 'comment': '', 'id': '', 'stock_link': '0', 'install_perc': '', 
    'install_amount': '', 'advanced_amount': '', 'price_w_tax': '', 'discount_perc': '', 
    'discount_header_perc': ''
  };

  // count = 1;
  result = { 'dp': [], 'stock_list': {} };
  public dp = [];
  stock_list = {};
  qty_list = {};
  
  // displayedColumns = ['chx_del', 'sub_item_no', 'sub_item_name', 'avail_amount',
  //   'unit_id', 'min_price', 'price', 'count', 'total_price', 'tax_no', 'discount', 'net_price', 'comment'];
  displayedColumns = ['chx_del', 'sub_item_number', 'sub_item_no', 'sub_item_name',
    'unit_name', 'price', 'count', 'total_price', 'discount', 'tax_amount', 'net_price', 'location', 'comment',
    'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;
  
  // subItemDialogRef: MatDialogRef<SuppInvSearchSubitemComponent>;
  commentDialogRef: MatDialogRef<InvoiceItemCommentComponent>;

  taxList = [];
  sub_item_unit = [];
  general_item_unit = [];
  add_inv_item;
  public item_count = 0;
  org_unit_no = 0;
  revenue_acct_no = '';
  sale_ret_acct_no = '';
  // is_general_item = false;

  @HostListener('window:keydown', ['$event'])
  handleKeyDownEvent(event: KeyboardEvent) {
    if (event.key == "Enter")
      (document.getElementById('sub_item_no') as HTMLInputElement).focus();

    if (event.key == "F2")
      this.addGeneralItem();

    if (event.key == "F9") {
      let searchItemField = document.getElementById('search_value_10') as HTMLInputElement;
      searchItemField.focus();
      searchItemField.select();
    }

    if (event.altKey && (event.key == 'u' || event.key == 'U'))
      (document.getElementById('unit_no') as HTMLInputElement).focus();

    if (event.altKey && (event.key == 'q' || event.key == 'Q')) {
      let countField = document.getElementById('count') as HTMLInputElement;
      countField.focus();
      countField.select();
    }

    if (event.altKey && (event.key == 'p' || event.key == 'P')) {
      let priceField = document.getElementById('price') as HTMLInputElement;
      priceField.focus();
      priceField.select();
    }

    if (event.altKey && (event.key == 's' || event.key == 'S')) {
      let discountField = document.getElementById('discount') as HTMLInputElement;
      discountField.focus();
      discountField.select();
    }

    if (event.altKey && (event.key == 't' || event.key == 'T'))
      (document.getElementById('tax_no') as HTMLInputElement).focus();

    if (event.altKey && (event.key == 'r' || event.key == 'R'))
      this.delLine();

    if (event.altKey && (event.key == 'c' || event.key == 'C'))
      this.highlightRow();

    if (event.altKey && event.key == 'ArrowUp')
      this.getHighlightRow('up');

    if (event.altKey && event.key == 'ArrowDown')
      this.getHighlightRow('down');

    if (event.altKey && (event.key == 'm' || event.key == 'M'))
      this.getHighlightRow('edit');

    if (event.altKey && (event.key == 'w' || event.key == 'W'))
      this.getHighlightRow('delete');

    if (event.altKey && (event.key == 'n' || event.key == 'N'))
      (document.getElementById('item_discount_perc') as HTMLInputElement).focus();

    if (event.altKey && (event.key == 'x' || event.key == 'X'))
      (document.getElementById('price_w_tax') as HTMLInputElement).focus();
  }

  Del_Line_Msg; Cant_Add_Msg1; Cant_Add_Msg2; Min_Amount_Msg1; Min_Amount_Msg2; Req_Amount_Msg2;
  General_Stock_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog,
    public translate: TranslateService, private changeDetectorRefs: ChangeDetectorRef) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Del_Line_Msg').subscribe((res: string) => {
      this.Del_Line_Msg = res;
    });

    translate.get('Cant_Add_Msg1').subscribe((res: string) => {
      this.Cant_Add_Msg1 = res;
    });

    translate.get('Cant_Add_Msg2').subscribe((res: string) => {
      this.Cant_Add_Msg2 = res;
    });

    translate.get('Min_Amount_Msg1').subscribe((res: string) => {
      this.Min_Amount_Msg1 = res;
    });

    translate.get('Min_Amount_Msg2').subscribe((res: string) => {
      this.Min_Amount_Msg2 = res;
    });

    translate.get('Req_Amount_Msg2').subscribe((res: string) => {
      this.Req_Amount_Msg2 = res;
    });

    translate.get('General_Stock_Msg').subscribe((res: string) => {
      this.General_Stock_Msg = res;
    });

  }

  ngOnInit() {
    (document.getElementById('sub_item_no') as HTMLInputElement).focus();

    let query, obj, selObj;

    // get leaf income accts
    let parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.data['list'].length > 0)
          this.revenue_acct_no = data.data['list'][0]['acct_number'];
      });

    parent_acct = this.applicationConstants.main_acct_config['income_acct'];
    obj = { cmd: 'getAccountList', parent_acct: parent_acct, add_leaf: true, only_leaf: true };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.sale_ret_acct_no = data.data['list'][0]['acct_number'];
      });

    query = this.queryList.all_unit;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.general_item_unit = data.data['list'];
        this.general_item_unit.forEach(element => {
          element.unit_no = element.unit_id;
        }),
          this.general_item_unit.unshift({
            'unit_id': '0', 'unit_no': '0', 'unit_name': 'لايوجد',
            'unit_name_en': 'Without'
          });
      });

    query = this.queryList.all_tax_types;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.taxList = data.data['list'];

        selObj = { 'acct_number': '0', 'tax_name_ar': 'اختر', 'tax_name_en': 'Select' };
        this.taxList.unshift(selObj);
      });

    this.add_inv_item = this.utils.getParamValue('add_inv_item');
    
  }

  ngOnChanges() {
    // console.log(this.invoice_item);
    if (this.invoice_item != undefined && this.invoice_item.length > 0) {
      this.dp = [];

      this.item_count = this.invoice_item.length;
      this.dp = this.invoice_item;
      this.dataSource.data = this.dp;
      this.dataSource._updateChangeSubscription();
      
      this.highlightRow();
      this.calculateTotal();

      console.log(this.model.invoice_type); 
      
      if (this.model.invoice_type == 'advanced' || this.model.invoice_type == 'install' || this.model.invoice_type == 'qty_install') {
        (document.getElementById('sub_item_no') as HTMLInputElement).disabled = true;
        (document.getElementById('search_value_10') as HTMLInputElement).disabled = true;
        (document.getElementById('btn_addGenItem') as HTMLButtonElement).disabled = true;
        (document.getElementById('unit_no') as HTMLInputElement).disabled = true;
        (document.getElementById('count') as HTMLInputElement).disabled = true;
        (document.getElementById('price') as HTMLInputElement).disabled = true; 
        (document.getElementById('tax_no') as HTMLInputElement).disabled = true;

        if (this.model.invoice_type == 'advanced') {
          (document.getElementById('install_perc') as HTMLInputElement).disabled = true;

          this.displayedColumns = ['chx_del', 'sub_item_number', 'sub_item_no', 'sub_item_name',
          'unit_name', 'price', 'count', 'total_price', 'discount', 'tax_amount', 'net_price', 'location', 
          'comment'];
        }
        else if (this.model.invoice_type == 'install' || this.model.invoice_type == 'qty_install') {

          if (this.model.invoice_type == 'qty_install') 
            (document.getElementById('discount') as HTMLInputElement).disabled = true;

          this.displayedColumns = ['chx_del', 'sub_item_number', 'sub_item_no', 'sub_item_name',
          'unit_name', 'price', 'count', 'total_price', 'discount', 'tax_amount', 'net_price', 'location', 
          'comment', 'edit'];
        }
      }

      
      //   (document.getElementById('count') as HTMLInputElement).disabled = true;
    }
  }

  ngAfterViewInit() {
    //(document.getElementById('sub_item_no_1') as HTMLInputElement).focus();
  }

  onChangeSearch = function (search_result: object) {
    // console.log(search_result);

    if (search_result['no'] != '') {

      let all_stock = true;
      if (this.model['table_name'] == 'purchase_order') {

        this.dp.forEach(element => {
          if (element.sub_item_no == '') {
            all_stock = false;
            return false;
          }
        });
      }

      console.log(all_stock);
      if (all_stock) {
        this.inv_model['sub_item_no'] = search_result['no'];
        this.getSubItemByNo(this.inv_model['sub_item_no']);
      }
      else
        alert(this.General_Stock_Msg);
      
    }
    else if (search_result['value'] != '') {
      this.inv_model['sub_item_no'] = '';
      this.inv_model['sub_item_number'] = '';

      this.inv_model['discount'] = '0';
    }
    console.log('value in item: ' + search_result['value']);
  }

  delLine() {
    let count = 0;
    let row_id; // total_price, tax_amount, discount, net_price;
    
    for (let index = (this.dp.length - 1); index >= 0; index--) {
      row_id = this.dp[index]['id'];
      if ((document.getElementById('chx_del_' + row_id) as HTMLInputElement).checked) {

        // TO DO
        //if the flag is not 'new' add to delete array
        
        if (this.data_model['type'] == '' || this.data_model['type'] == 'invoice') {
          if (this.dp[index]['invoice_item_id'] != '') {
            this.dp[index]['flag'] = 'delete';
            this.dp[index]['table_name'] = 'invoice_item';
            this.toDelete.push(this.dp[index]);
          }
  
          if (this.add_inv_item == '0')
            this.qty_list[this.dp[index]['sub_item_no']] -= Number(this.dp[index]['count']);
        }
        else if (this.data_model['type'] == 'return_invoice') {

          if (this.dp[index]['return_item_id'] != '') {
            this.dp[index]['flag'] = 'delete';
            this.dp[index]['table_name'] = 'return_invoice_item';
            this.toDelete.push(this.dp[index]);
          }
        }
        else if (this.data_model['type'] == 'qutation') {

          if (this.dp[index]['qutation_item_id'] != '0') {
            this.dp[index]['flag'] = 'delete';
            this.dp[index]['table_name'] = 'qutation_item';
            this.toDelete.push(this.dp[index]); 
          }
        }

        this.dp.splice(index, 1);

        count++;
        this.item_count = this.item_count - 1;
      }
    }

    if (count == 0)
      alert(this.Del_Line_Msg);
    else {

      this.dataSource.data = this.dp;
      this.changeDetectorRefs.detectChanges();

      this.highlightRow();
      this.calculateTotal();

      this.result['dp'] = this.dp;
      this.result['stock_list'] = this.stock_list;
      this.dpList.emit(this.result);
    }
  }

  getSubItem(event) {
    // let id = event.srcElement.id;
    // let sub_item_no = event.srcElement.value;

    // if (sub_item_no != '')
    //   this.getSubItemByNo(sub_item_no);

    let all_stock = true;
    if (this.model['table_name'] == 'purchase_order') {

      this.dp.forEach(element => {
        if (element.sub_item_no == '') {
          all_stock = false;
          return false;
        }
      });
    }

    console.log(all_stock);
    if (all_stock) {

      let id = event.srcElement.id;
      let sub_item_no = event.srcElement.value;

      if (sub_item_no != '')
        this.getSubItemByNo(sub_item_no);
    }
    else
      alert(this.General_Stock_Msg);
  }

  getSubItemByNo(sub_item_no) {
    console.log('test: ' + sub_item_no);
    let invoice_item = [];

    if (this.model['table_name'] == 'invoice' && this.add_inv_item == '1') {
      this.dp.forEach(element => {
        invoice_item.push({
          'sub_item_no': element.sub_item_no, 'sub_item_number': element.sub_item_number
          //sub_item_number: (document.getElementById('sub_item_number_' + element.id) as HTMLInputElement).value
        });
      });
    }

    let obj = {
      cmd: 'getSubItemByBarcode', sub_item_no: sub_item_no, invoice_item: invoice_item,
      store_id: (this.model['flag'] == 'update' ? this.model['store_id'] : this.applicationConstants.user_branch_info.user_store_id)
    };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log('test2: ' + sub_item_no);
        console.log(data);

        if (data.status['type'] == 'error') {
          alert(data.status['msg']);
        }
        else {
          let sub_item = data.status['msg'][0];
          console.log(sub_item);
          let available_count, sub_item_count;

          if (data.status['type'] == 'exist') {
            this.dp.forEach(element => {
              if (element.sub_item_number == sub_item.sub_item_number) {
                available_count = element.avail_amount;
                sub_item_count = Number((sub_item.min_sale_qty > 0 ? sub_item.min_sale_qty : 1));
                sub_item_count += Number(element.count);

                if (this.model['table_name'] == 'invoice' && String(available_count) != '' &&
                  (available_count <= 0 || available_count < sub_item_count))
                  alert(this.Cant_Add_Msg1 + sub_item_no + this.Cant_Add_Msg2);
                else {
                  this.inv_model['id'] = element.id;
                  this.inv_model['count'] = sub_item_count;
                  element.count = sub_item_count;

                  this.checkCount(null, sub_item_count);
                  this.calculateTotal();
                }
                
                return false;

              }
            });
          }
          else if (data.status['type'] == 'success') {
            // alert(data.status['type']);
            available_count = sub_item.available_count;
            let item_qty = 0;
            
            if (this.model['table_name'] == 'purchase_order')
              sub_item_count = 1;
            else {
              if (this.add_inv_item == '1')
                sub_item_count = Number((sub_item.min_sale_qty > 0 ? sub_item.min_sale_qty : 1));
              else if (this.add_inv_item == '0') {
                if (this.qty_list[sub_item.sub_item_no] == undefined) 
                  sub_item_count = Number((sub_item.min_sale_qty > 0 ? sub_item.min_sale_qty : 1));
                else {
                  item_qty = Number((sub_item.min_sale_qty > 0 ? sub_item.min_sale_qty : 1));
                  sub_item_count = Number(this.qty_list[sub_item.sub_item_no]) + item_qty;
                }
              }
            }
             
            if (this.model['table_name'] == 'invoice' && sub_item.stock_link == '1' && String(available_count) != ''
              && (available_count <= 0 || available_count < sub_item_count)) {
              alert(this.Cant_Add_Msg1 + sub_item_no + this.Cant_Add_Msg2);
            }
            else {
              this.inv_model['sub_item_number'] = sub_item.sub_item_number;
              this.inv_model['stock_link'] = sub_item.stock_link;
              this.inv_model['avail_amount'] = available_count;
              this.inv_model['unit_no'] = sub_item.unit_no;

              this.sub_item_unit = sub_item.sub_item_unit;

              if (this.model['table_name'] == 'purchase_order') {
                this.inv_model['price'] = sub_item.cost;
                (document.getElementById('price') as HTMLInputElement).disabled = (sub_item.price_flex != '1');
              }
              else {
                this.inv_model['price'] = sub_item.price;
                if (this.model.invoice_type != 'install')
                  (document.getElementById('price') as HTMLInputElement).disabled = (sub_item.price_flex != '1');
              }

              this.inv_model['count'] = (this.add_inv_item == '0' && this.qty_list[sub_item.sub_item_no] != undefined ? item_qty : sub_item_count);
              this.inv_model['total_price'] = (Number(this.inv_model['price']) * sub_item_count).toFixed(2);
      
              this.inv_model['discount_header_perc'] = (this.model['table_name'] == 'invoice' ? (document.getElementById('discount_header_perc') as HTMLInputElement).value : '0');
              this.inv_model['min_sale_qty'] = sub_item.min_sale_qty;
              let discount = 0, tax_perc = 0, tax_amnt = 0;

              discount = (Number(this.inv_model['discount_header_perc']) > 0 ? ((Number(this.inv_model['price']) * sub_item_count) * (Number(this.inv_model['discount_header_perc']) / 100)) : 0);
              this.inv_model['discount'] = discount.toFixed(2);
              this.inv_model['tax_amount'] = '0';

              if (this.model['calc_tax'] == '1') {
                this.inv_model['tax_no'] = (sub_item.def_tax_acct != '' ? String(sub_item.def_tax_acct) : '0');

                if (sub_item.def_tax_acct != '' && sub_item.def_tax_acct != '0') {

                  for (let indx = 1; indx < this.taxList.length; indx++) {
                    let element = this.taxList[indx];
                    if (element.acct_number == this.inv_model['tax_no']) {
                      if (element.tax_perc != 0)
                        tax_perc = element.tax_perc;
                      else if (element.tax_amount != 0)
                        tax_amnt = element.tax_amount;
                    }
                  }
                }

                if (tax_perc != 0)
                  this.inv_model['tax_amount'] = (((Number(this.inv_model['price']) * sub_item_count) - discount) * (tax_perc / 100)).toFixed(2);
                else if (tax_amnt != 0)
                  this.inv_model['tax_amount'] = tax_amnt.toFixed(2);
              }
              else
                this.inv_model['tax_no'] = '0'; // this.taxList[0].acct_number;

              this.inv_model['net_price'] = ((Number(this.inv_model['price']) * sub_item_count) - discount + Number(this.inv_model['tax_amount'])).toFixed(2);

              let next_id = 1;
              if (this.dp.length > 0)
                next_id = Number(this.dp[this.dp.length - 1]['id']) + 1;

              this.inv_model['id'] = String(next_id);
 
              // let warranty = '';
              // if ((sub_item.warranty_day != '' && sub_item.warranty_day != '0') || (sub_item.warranty_kilometer != '' && sub_item.warranty_kilometer != '0')) {
              //   warranty = '- ضمان ' + sub_item.warranty_day + ' يوم أو ' + sub_item.warranty_kilometer + ' كيلومتر أيهما أقرب';
              //   console.log(warranty);
              // } 'available_stock': sub_item.available_stock, 
              if (this.add_inv_item == '0')
                this.qty_list[sub_item.sub_item_no] = sub_item_count;

              if (this.stock_list[sub_item.sub_item_no] == undefined)
                this.stock_list[sub_item.sub_item_no] = sub_item.available_stock;
              
              this.item_count++;
              this.dp.push({
                'id': next_id, 'chx_del': '', 'sub_item_no': this.inv_model['sub_item_no'],
                'sub_item_name': sub_item.main_item_name + '-' + sub_item.main_item_name_en,
                'unit_name': sub_item['unit_name'], 'unit_name_en': sub_item['unit_name_en'],
                'price': this.inv_model['price'], 'count': this.inv_model['count'],
                'total_price': this.inv_model['total_price'], 'tax_amount': this.inv_model['tax_amount'],
                'discount': this.inv_model['discount'], 'net_price': this.inv_model['net_price'],
                'serial': this.inv_model['serial'], 'comment': this.inv_model['comment'],
                'unit_id': sub_item['unit_id'], 'unit_no': this.inv_model['unit_no'],
                'stock_link': sub_item.stock_link, 'tax_no': this.inv_model['tax_no'],
                'tax_perc': tax_perc, 'tax_amnt': tax_amnt, 'sub_item_number': this.inv_model['sub_item_number'], 
                'sub_item_name_en': sub_item.main_item_name_en, 'key': (this.model['table_name'] == 'qutation' ? 'qutation_item_id' : 'invoice_item_id'),
                'available_count': available_count, 'sub_item_unit': sub_item.sub_item_unit, 
                'invoice_item_id': '', 'primary_sub_item_number': sub_item.primary_sub_item_number,
                'primary_quantity': sub_item.primary_quantity, 'revenue_acct_no': sub_item.revenue_acct_no,
                'sale_ret_acct_no': sub_item.sale_ret_acct_no, 'flag': 'new', 
                'def_tax_acct': sub_item.def_tax_acct, 'warranty_day': sub_item.warranty_day, 
                'warranty_kilometer': sub_item.warranty_kilometer, 'min_sale_qty': sub_item.min_sale_qty,
                'price_flex': sub_item.price_flex, 'discount_perc': '0', 'price_w_tax': '0', 
                'discount_header_perc': (this.model['table_name'] == 'invoice' ? (document.getElementById('discount_header_perc') as HTMLInputElement).value : '0'),
                'has_discount_value': '0'
              });

              if (this.model['table_name'] == 'qutation')
                this.dp[this.dp.length - 1]['qutation_item_id'] = '0';
              // console.log("DP: ");
              // console.log(this.dp);

              this.table.renderRows();
              this.highlightRow();
              this.calculateTotal();

            }
          }
        }

        this.inv_model['sub_item_no'] = '';
        (document.getElementById('search_value_10') as HTMLInputElement).value = '';
        (document.getElementById('sub_item_no') as HTMLInputElement).focus();

      });

    // let all_stock = true;
    // if (this.model['table_name'] == 'purchase_order') {

    //   this.dp.forEach(element => {
    //     if (element.sub_item_no == '') {
    //       all_stock = false;
    //       return false;
    //     }
    //   });
    // }
   
    // console.log(all_stock);
    // if (all_stock) {
    //   console.log('test: ' + sub_item_no);
    //   // this.is_general_item = false;
    //   let invoice_item = [];
    //   if (this.add_inv_item == '1') {
    //     this.dp.forEach(element => {
    //       invoice_item.push({
    //         'sub_item_no': element.sub_item_no, 'sub_item_number': element.sub_item_number
    //         //sub_item_number: (document.getElementById('sub_item_number_' + element.id) as HTMLInputElement).value
    //       });
    //     });
    //   }
    // }
    // else
    //   alert(this.General_Stock_Msg);
  }

  addGeneralItem() {

    //If it is a purchase order you can't add general items and stock items at the same time
    let all_general = true;
    if (this.model['table_name'] == 'purchase_order') {

      this.dp.forEach(element => {
        if (element.sub_item_no != '') {
          all_general = false;
          return false;
        }
      });
    }
    (document.getElementById('price') as HTMLInputElement).disabled = false;
    console.log(all_general);
    if (all_general) {
      console.log('general item');
      let next_id = 1;
      if (this.dp.length > 0)
        next_id = Number(this.dp[this.dp.length - 1]['id']) + 1;
      this.sub_item_unit = this.general_item_unit;

      this.inv_model = {
        'avail_amount': '', 'unit_no': this.sub_item_unit[0]['unit_no'], 'count': '1', 'price': '0', 'discount': '0',
        'net_price': '0', 'location': '', 'serial': '', 'sub_item_no': '', 'sub_item_number': '', 'tax_no': '0',
        'total_price': '0', 'tax_amount': '0', 'min_sale_qty': '', 'comment': '', 'id': String(next_id),
        'stock_link': '0', 'install_perc': '0', 'install_amount': '', 'advanced_amount': '0', 'price_w_tax': '0', 'discount_perc': '0',
        'discount_header_perc': (this.model['table_name'] == 'invoice' ? (document.getElementById('discount_header_perc') as HTMLInputElement).value : '0')
      };

      let tax_perc = 0, tax_amnt = 0;
      if (this.model['calc_tax'] == '1') {
        this.inv_model['tax_no'] = this.taxList[1].acct_number;
        if (this.taxList[1].tax_perc != 0)
          tax_perc = this.taxList[1].tax_perc;
        else if (this.taxList[1].tax_amount != 0)
          tax_amnt = this.taxList[1].tax_amount;
      }
      else
        this.inv_model['tax_no'] = this.taxList[0].acct_number;

      this.item_count++;
      this.dp.push({
        'id': next_id, 'chx_del': '', 'sub_item_no': '',
        'sub_item_name': (document.getElementById('search_value_10') as HTMLInputElement).value,
        'unit_name': this.sub_item_unit[0]['unit_name'], 'price': this.inv_model['price'],
        'count': this.inv_model['count'], 'total_price': this.inv_model['total_price'],
        'tax_amount': this.inv_model['tax_amount'], 'discount': this.inv_model['discount'],
        'net_price': this.inv_model['net_price'], 'serial': this.inv_model['serial'],
        'comment': this.inv_model['comment'], 'unit_id': this.sub_item_unit[0]['unit_ie'],
        'unit_no': this.inv_model['unit_no'], 'stock_link': '0', 'tax_no': this.inv_model['tax_no'], 
        'tax_perc': tax_perc, 'tax_amnt': tax_amnt, 'sub_item_number': this.inv_model['sub_item_number'],
        'sub_item_name_en': '', 'available_stock': '', 'available_count': '', 'sub_item_unit': this.sub_item_unit,
        'unit_list': this.sub_item_unit, 'invoice_item_id': '', 'key': 'invoice_item_id', 'flag': 'new',
        'primary_sub_item_number': '0', 'primary_quantity': '0', 
        'revenue_acct_no': this.revenue_acct_no, 'sale_ret_acct_no': this.sale_ret_acct_no,
        'price_flex': '1', 
        'discount_header_perc': (this.model['table_name'] == 'invoice' ? (document.getElementById('discount_header_perc') as HTMLInputElement).value : '0'),
        'price_w_tax': '0', 'discount_perc': '0', 'has_discount_value': '0'
      });
      
      this.table.renderRows();
      //this.changeDetectorRefs.detectChanges();
      this.highlightRow();
      this.calculateTotal();
      // this.count++;

      this.inv_model['sub_item_no'] = '';
      (document.getElementById('sub_item_no') as HTMLInputElement).focus();
    }
    else
      alert(this.General_Stock_Msg);
  }

  getHighlightRow(opType) {
    let table = (document.getElementById('sub_item_table') as HTMLSourceElement);
    let table_row, row_index;

    for (let index = 1; index < table.childElementCount; index++) {
      table_row = table.children[index];
      // console.log(table_row.style.backgroundColor);
      if (table_row.style.backgroundColor == "yellow") {
        row_index = index;
        break;
      }
    }
    console.log(row_index);

    if (opType == 'up') {
      row_index = row_index - 1;
      if (row_index > 0)
        this.highlightRow('', row_index, opType);
    }
    else if (opType == 'down') {
      row_index = row_index + 1;
      if (row_index <= this.dp.length)
        this.highlightRow('', row_index, opType);
    }
    else if (opType == 'edit')
      this.editSubItem(this.dp[row_index - 1]);
    else if (opType == 'delete')
      this.delSubItem(this.dp[row_index - 1].id);
  }

  // highlightNextRow(type) {

  //   let table = (document.getElementById('sub_item_table') as HTMLSourceElement);
  //   let table_row, row_index;

  //   for(let index = 1; index < table.childElementCount; index++) {
  //     table_row = table.children[index];
  //     if (table_row.style.background == "yellow") {
  //       row_index = index;
  //       break;
  //     }
  //   }

  //   if (type == 'up')
  //     row_index = row_index - 2;

  //   if (row_index >= 0 && row_index < this.dp.length)
  //     this.highlightRow('', row_index);
  // }

  highlightRow(rowId = '', rowIndex = '', opType = '') {
    console.log('rowId: ' + rowId);
    console.log('rowIndex: ' + rowIndex);
    let row_index = 0;

    if (rowIndex == '') {
      if (rowId == '')
        row_index = this.dp.length; // this.item_count;
      else
        row_index = this.utils.getDPIndex(this.dp, 'id', rowId);
      // row_index = this.getDPIndex(rowId) + 1;
    }
    else
      row_index = Number(rowIndex);

    console.log('row_index: ' + row_index);

    let table = (document.getElementById('sub_item_table') as HTMLSourceElement);
    let table_row;
    // console.log('childElementCount: ' + table.childElementCount);
    for (let index = 1; index < table.childElementCount; index++) {
      table_row = table.children[index];
      table_row.style.background = (index == row_index ? "yellow" : (index % 2 == 0 ? "transparent" : "#ececec"));
    }

    var element = document.getElementById("div_container");
    // console.log('scrollHeight: ' + element.scrollHeight);
    if (opType == '') {
      if (row_index == this.item_count) {
        if (element.scrollHeight > 205)
          element.scrollTop = element.scrollHeight;
      }
    }
    else if (element.scrollHeight > 205) {
      console.log('scrollTop: ' + element.scrollTop);
      element.scrollTop = (opType == 'up' ? element.scrollTop - 40 : element.scrollTop + 40);
    }
  }

  emptyInvoiceItem(row_id) {
    (document.getElementById('chx_del_' + row_id) as HTMLInputElement).checked = true;
    this.delLine();
  }

  getUnit(event) {
    this.org_unit_no = event.srcElement.value;
  }

  changeUnit(event) {
    let id = event.srcElement.id;
    let unit_no = event.srcElement.value;
    let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
    
    if (this.dp[dp_index].sub_item_no == '') {
      console.log('sub_item_no: ' + this.dp[dp_index].sub_item_no);
      this.dp[dp_index].sub_item_unit.forEach(unit => {
        if (unit.unit_id == unit_no) {
          this.dp[dp_index]['unit_id'] = unit.unit_id;
          this.dp[dp_index]['unit_no'] = unit.unit_no;
          this.dp[dp_index]['unit_name'] = unit.unit_name;
          this.dp[dp_index]['unit_name_en'] = unit.unit_name_en;

          this.dataSource.data = this.dp;
          this.dataSource._updateChangeSubscription();
          return false
        }
      });
    }
    else {

      this.dp[dp_index].sub_item_unit.forEach(element => {
        if (unit_no == element.unit_no) {
          //let sub_item_count = Number((document.getElementById('count_' + row_id) as HTMLInputElement).value);
          let sub_item_count = Number(this.inv_model['count']);
          if (this.dp[dp_index].stock_link == '1' && element.available_count != '' && element.available_count < sub_item_count)
            sub_item_count = (element.min_sale_qty > 0 ? element.min_sale_qty : 1);

          if (this.dp[dp_index].stock_link == '1' && element.available_count != '' && (element.available_count <= 0 || element.available_count < sub_item_count)) {
            //let sub_item_no = (document.getElementById('sub_item_no_' + row_id) as HTMLInputElement).value;
            // let sub_item_no = this.inv_model['sub_item_no'];
            alert(this.Cant_Add_Msg1 + element.sub_item_no + this.Cant_Add_Msg2);
            (document.getElementById(id) as HTMLInputElement).value = String(this.org_unit_no);
          }
          else {
            let existed = false;

            //// ****************** if add_inv_item is '1', check availabiltiy of sub item ****************** ////
            if (this.add_inv_item == '1') {
              this.dp.forEach(element1 => {
                //if ((document.getElementById('sub_item_number_' + element1.id) as HTMLInputElement).value == element.sub_item_number) {
                if (this.inv_model['sub_item_number'] == element.sub_item_number) {
                  existed = true;
                  this.item_count--;
                  //sub_item_count += Number((document.getElementById('count_' + element1.id) as HTMLInputElement).value);
                  sub_item_count += Number(this.inv_model['count']);

                  if (element1.stock_link == '1' && element1.available_count != '' && (Number(element1.available_count) <= 0 || Number(element1.available_count) < sub_item_count)) {
                    //let sub_item_no = (document.getElementById('sub_item_no_' + row_id) as HTMLInputElement).value;
                    alert(this.Cant_Add_Msg1 + element.sub_item_no + this.Cant_Add_Msg2);
                    (document.getElementById(id) as HTMLInputElement).value = String(this.org_unit_no);
                  }
                  else {
                    //(document.getElementById('count_' + element1.id) as HTMLInputElement).value = String(sub_item_count);
                    this.inv_model['count'] = String(sub_item_count);
                    this.calculateTotal();
                    //(document.getElementById('chx_del_' + row_id) as HTMLInputElement).checked = true;
                    this.delLine();
                  }
                  return false;
                }
              });
            }

            if (!existed) {
              this.dp[dp_index]['sub_item_no'] = element.sub_item_no;
              this.dp[dp_index]['sub_item_number'] = element.sub_item_number;
              this.dp[dp_index]['available_count'] = element.available_count;
              this.dp[dp_index]['available_stock'] = element.available_stock;
              console.log(element.available_stock);
              this.dp[dp_index]['price'] = element.price;
              if (this.model.invoice_type != 'install')
                (document.getElementById('price') as HTMLInputElement).disabled = (element.price_flex != '1');
              this.dp[dp_index]['count'] = String(sub_item_count);
              this.dp[dp_index]['tax_no'] = this.inv_model['tax_no'];

              this.inv_model['sub_item_no'] = element.sub_item_no;
              this.inv_model['sub_item_number'] = element.sub_item_number;
              this.inv_model['avail_amount'] = element.available_count;
              this.inv_model['unit_no'] = element.unit_no;
              this.inv_model['price'] = element.price;
              this.inv_model['count'] = String(sub_item_count);

              this.calculateTotal(this.inv_model['id']);

              this.dp[dp_index]['unit_id'] = element.unit_id;
              this.dp[dp_index]['unit_no'] = element.unit_no;
              this.dp[dp_index]['unit_name'] = element.unit_name;
              this.dp[dp_index]['unit_name_en'] = element.unit_name_en;

              this.dataSource.data = this.dp;
              this.dataSource._updateChangeSubscription();
            }
          }
          return false;
        }
      });
    }
  }

  changePrice(event) {
    let id = event.srcElement.id;
    // console.log(event.srcElement.value);
    if (isNaN(Number(event.srcElement.value))) {
      this.inv_model['price'] = String(parseFloat(event.srcElement.value));
      (document.getElementById('price') as HTMLInputElement).value = this.inv_model['price'];
    }

    if (isNaN(Number(event.srcElement.value))) {
      this.inv_model['price'] = '0';
      (document.getElementById('price') as HTMLInputElement).value = '0';
    }

    if (!isNaN(Number(event.srcElement.value))) {
      // let row_id = id.substring(id.lastIndexOf('_') + 1);

      // let dp_index = this.getDPIndex(this.inv_model['id']);
      let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
      this.dp[dp_index]['price'] = this.inv_model['price'];
      this.calculateTotal(this.inv_model['id']);

      let taxObj = this.getTax(this.inv_model.tax_no);
      this.inv_model['price_w_tax'] = ''; // (Number(this.inv_model['price']) * (1 + taxObj.tax_perc)).toFixed(2);
      this.inv_model['discount_perc'] = '';
      let discount_perc = ''; // (Number(this.inv_model['discount_perc']) + Number(this.inv_model['discount_header_perc'])) / 100 ;
      // this.inv_model.discount = (Number(this.inv_model['price']) * discount_perc).toFixed(2); 

    }
  }

  changeCount(event) {
    // let id = event.srcElement.id;
    let count = Number(event.srcElement.value);

    if (isNaN(count)) {
      this.inv_model['count'] = String(parseFloat(event.srcElement.value));
      count = Number(this.inv_model['count']);
      (document.getElementById('count') as HTMLInputElement).value = this.inv_model['count'];
    }

    if (isNaN(count)) {
      this.inv_model['count'] = '0';
      (document.getElementById('count') as HTMLInputElement).value = '0';
    }

    if (count >= Number(this.inv_model['min_sale_qty'])) {
      console.log(count);

      // let dp_index = this.getDPIndex(this.inv_model['id']);
      let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
      this.dp[dp_index]['count'] = this.inv_model['count'];
      this.calculateTotal(this.inv_model['id']);
    }
  }

  calculateTotal(id = '') {
    let total_price, net_total_price = 0, tax_amount = 0, total = 0, tax = 0, discount = 0, 
      install_amount = 0, advanced_amount = 0, total_advanced = 0;
    let tax_perc = 0, tax_amt = 0, itemDiscount = 0;
    // total_w_advanced = 0;

    this.dp.forEach(element => {
      console.log('element: ');
      console.log(element); 

      if (element.revenue_acct_no == '0')
        element.revenue_acct_no = this.revenue_acct_no;
        
      total_price = Number(element.price) * Number(element.count);

      if (element.discount_perc == undefined) 
        element.discount_perc = '';
      if (element.discount_header_perc == undefined) 
        element.discount_header_perc = '';

      if (element.has_discount_value == '1')  
        itemDiscount = Number(element.discount);
      else {
        if (Number(element.discount_perc) > 0 || Number(element.discount_header_perc) > 0) {
          itemDiscount = total_price * (Number(element.discount_perc) + Number(element.discount_header_perc)) / 100;
          element.discount = Number(itemDiscount).toFixed(2);
        }
        else
          itemDiscount = Number(element.discount);
      }

      net_total_price = total_price - itemDiscount; //Number(element.discount);
      discount += itemDiscount;//Number(element.discount);

      if (element.id == this.inv_model['id'])
        this.inv_model['discount'] = itemDiscount.toFixed(2);

      element.discount = itemDiscount.toFixed(2);
      element.price = Number(element.price).toFixed(2);

      if (this.model.invoice_type != 'advanced' && this.model.invoice_type != 'install') {
        total += total_price;
      }
      else {
        install_amount = net_total_price * (Number(element.install_perc) / 100);
        advanced_amount = install_amount * (Number(this.data_model['advanced_perc']) / 100);
        net_total_price = (install_amount - advanced_amount);

        total += install_amount;
        total_advanced += advanced_amount;
      }
      tax_amount = 0;

      if (this.model['calc_tax'] == '1' && element.tax_no != '0') {
        if (this.model.invoice_type != 'advanced') {
          if (element.tax_perc != 0)
            tax_amount = net_total_price * (element.tax_perc / 100);
          else if (element.tax_amount != 0)
            tax_amount = element.tax_amnt;
        }
        else {
          tax_amount = 0;
          element.tax_amount = tax_amount.toFixed(2);
          
          if (tax_perc == 0 && element.tax_perc != 0)
            tax_perc = element.tax_perc;
          else (tax_amt == 0 && element.tax_amount != 0)
            tax_amt = element.tax_amount;
        }
      }
      console.log('tax_amount: ' + tax_amount);
      net_total_price += tax_amount;
      tax += tax_amount;

      if (id != '' && Number(id) == Number(element.id)) {
        element.total_price = total_price.toFixed(2);
        element.net_price = net_total_price.toFixed(2);
        element.tax_amount = tax_amount.toFixed(2);

        if (this.model.invoice_type == 'advanced' || this.model.invoice_type == 'install') {
          element.install_amount = install_amount;
          element.advanced_amount = advanced_amount;
        }
      }
    });
    console.log(this.dp);

    this.model['total'] = total.toFixed(2);
    this.model['tax'] = tax.toFixed(2);

    this.model['discount'] = discount.toFixed(2);
    this.data_model['item_discount'] = this.model['discount'];
    
    if (this.model.invoice_type == 'advanced') {
      advanced_amount = Number(this.data_model['qutation_total']) * (Number(this.data_model['advanced_perc'])/ 100)
      this.model['advanced_amount'] = advanced_amount.toFixed(2);
      this.data_model['total_w_advanced'] = this.model['advanced_amount'];

      if (this.model['calc_tax'] == '1') {
        if (tax_perc != 0)
          tax_amount = advanced_amount * (tax_perc / 100);
        else if (tax_amt != 0)
          tax_amount = tax_amt;
      }
      this.model['tax'] = tax_amount.toFixed(2);
      this.data_model['final_total'] = (advanced_amount + tax_amount).toFixed(2);
      this.data_model['rem_amount'] = (Number(this.data_model['first_balance']) - Number(this.model['advanced_amount'])).toFixed(2);
      this.model['rem_balance'] = this.data_model['rem_amount'];
    }
    else if (this.model.invoice_type == 'install' || this.model.invoice_type == 'qty_install') {
      this.model['advanced_amount'] = total_advanced.toFixed(2);
      this.data_model['total_w_advanced'] = (total - total_advanced).toFixed(2);
      this.data_model['final_total'] = (total - total_advanced + tax).toFixed(2);
      this.data_model['rem_amount'] = (Number(this.data_model['first_balance']) - Number(this.data_model['total_w_advanced'])).toFixed(2);
      this.model['rem_balance'] = this.data_model['rem_amount'];
    }
    else {
      this.data_model['final_total'] = (total - discount + tax).toFixed(2);
      this.data_model['paid_amount'] = '';
      this.data_model['rem_amount'] = '';
    }
    
    (document.getElementById('final_total') as HTMLInputElement).value = this.data_model['final_total'];

    this.result['dp'] = this.dp;
    this.result['stock_list'] = this.stock_list;
    this.dpList.emit(this.result);
  }

  checkCount(event = null, item_count = 0) {
    let count;
    if (event != null) {
      let id = event.srcElement.id;
      count = Number(event.srcElement.value);
    }
    else 
      count = item_count;
    
    if (this.dp.length > 0) {
      //let row_id = id.substring(id.lastIndexOf('_') + 1);
      let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);

      let min_sale_qty = Number(this.dp[dp_index]['min_sale_qty']);
      //let avail_amount = (document.getElementById('avail_amount_' + row_id) as HTMLInputElement).value;

      if (count < min_sale_qty) {
        alert(this.Min_Amount_Msg1 + this.dp[dp_index]['sub_item_no'] + this.Min_Amount_Msg2);
        this.inv_model['count'] = String(min_sale_qty);
        
      }
      else if (this.inv_model['stock_link'] == '1') {

        if (this.add_inv_item == '1' && this.dp[dp_index]['available_count'] != '' &&
          count > Number(this.dp[dp_index]['available_count'])) {
            alert(this.Min_Amount_Msg1 + this.dp[dp_index]['sub_item_no'] + this.Req_Amount_Msg2);
            this.inv_model['count'] = String(this.dp[dp_index]['available_count']);
        }
        else if (this.add_inv_item == '0') {
          let total_qty = 0;
          this.dp.forEach(element => {
            if (element.sub_item_no == this.dp[dp_index]['sub_item_no']) 
              total_qty += Number(element.count);
          });

          if (Number(this.dp[dp_index]['available_count']) < total_qty) {
            alert(this.Min_Amount_Msg1 + this.dp[dp_index]['sub_item_no'] + this.Req_Amount_Msg2);
            this.inv_model['count'] = String(Number(this.dp[dp_index]['available_count']) - (total_qty - Number(count)));
            this.qty_list[this.dp[dp_index]['sub_item_no']] = Number(this.dp[dp_index]['available_count']);
          }
          else 
            this.qty_list[this.dp[dp_index]['sub_item_no']] = total_qty;
        }
      }

      this.dp[dp_index]['count'] = this.inv_model['count'];
      this.calculateTotal(this.inv_model['id']);
    }
  }

  // fetch the tax percentage 
  getTax(tax_no) {
    //let tax_no = this.inv_model['tax_no'];
    let tax = this.taxList.filter((item)=>item.acct_number == tax_no);
    let taxObj = {tax_perc: 0, tax_amnt: 0};
    if(tax.length > 0){
      [taxObj.tax_perc, taxObj.tax_amnt] = [Number(tax[0].tax_perc)/100, Number(tax[0].tax_amnt)];
    }
    return taxObj;
  }

  calculatePrice(event) {
    let id = event.srcElement.id;
    let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
    ['discount','price','count','price_w_tax','discount_perc','tax_no','tax_amount'].forEach((key)=>{
      this.dp[dp_index][key] = this.inv_model[key];
    });

    if (id == 'item_discount_perc') {
      this.dp[dp_index]['discount'] = '0';
      this.dp[dp_index]['has_discount_value'] = '0';
    }

    this._calculatePrice(dp_index);
    ['discount','price','count','price_w_tax','discount_perc','tax_no','tax_amount'].forEach((key)=>{
      this.inv_model[key] = this.dp[dp_index][key];
    });
    
    //this.changePrice({srcElement:{id: 'price'}});
    this.calculateTotal(this.inv_model['id']);    
  }

  _calculatePrice(index){
    let taxObj = this.getTax(this.dp[index].tax_no);
    let price = Number(this.dp[index]['price']);
    let total_price = Number(this.dp[index]['total_price']);
    let priceWTax = Number(this.dp[index]['price_w_tax']);
    let discount_perc = (Number(this.dp[index]['discount_perc']) + Number(this.dp[index]['discount_header_perc'])) / 100 ;
    let taxAmount, discount;
    //let A = (1 - discount_perc) * taxObj.tax_perc;
    //let taxAmount = (A * priceWTax) / (1 + A);
    //this.dp[index]['tax_amount'] = taxAmount.toFixed(2);
    //let price = priceWTax - taxAmount; // / (1 + taxObj.tax_perc);
    console.log("price: " + price);
    console.log("total_price: " + total_price);
    console.log("priceWTax: " + priceWTax);
    console.log("has_discount_value: " + this.dp[index]['has_discount_value']);
    console.log("discount_perc: " + discount_perc);
    console.log("discount: " + Number(this.dp[index]['discount']));

    if (this.dp[index]['has_discount_value'] == '1')
      discount = Number(this.dp[index]['discount']);
    else {
      if (discount_perc > 0)
        discount = total_price * discount_perc;
      else 
        discount = Number(this.dp[index]['discount']);
    }
    console.log("discount: " + discount);

    if (priceWTax > 0) {
      if (taxObj.tax_perc > 0) 
        price = priceWTax / (1 + taxObj.tax_perc);
      else 
        price = priceWTax - taxObj.tax_amnt;
    }

    if (taxObj.tax_perc > 0)
      taxAmount = (total_price - discount) * taxObj.tax_perc;
    else
      taxAmount = taxObj.tax_amnt;

    // discount = Number(price) * Number(discount_perc);
    
    this.dp[index]['price'] = price.toFixed(2); 
    this.dp[index]['tax_amount'] = taxAmount.toFixed(2);
    this.dp[index]['discount'] = discount.toFixed(2);
    this.dp[index]['net_price'] = (total_price - discount + taxAmount).toFixed(2);
    console.log(`header discount: ${this.dp[index]['discount_header_perc']}, discount_perc: ${this.inv_model['discount_perc']}, discount: ${discount}, taxAmount: ${taxAmount}, price : ${price}`);
    //console.log(`discount_perc: ${this.inv_model['discount_perc']}, discount: ${discount}, taxAmount: ${taxAmount}, price : ${price}`);
    //this.changePrice({srcElement:{id: 'price'}});
    //this._updateLineItem(index);
  }

  _updateLineItem(index){
    // this.dp[index]['discount'] = this.inv_model['discount'];
    // this.dp[index]['price'] = this.inv_model['price'];
    // this.dp[index]['count'] = this.inv_model['count'];
    // this.dp[index]['price_w_tax'] = this.inv_model['price_w_tax'];
    // this.dp[index]['discount_perc'] = this.inv_model['discount_perc'];
    ['discount','price','count','price_w_tax','discount_perc'].forEach((key)=>{
      this.dp[index][key] = this.inv_model[key] ;
    });
    //this.calculateTotal(this.inv_model['id']);
  }

  _updateHeaderDiscount(discount_header_perc){
    //let discount_header_perc = (document.getElementById('discount_header_perc') as HTMLInputElement).value;
    /*try{
      this.inv_model.discount_header_perc = discount_header_perc; // update the discount header percentage in the currently editing model
      this.calculatePrice(); // calculate the price for currently selected item
    }catch(err){
      console.warn('There is no selected item to update!');
    }*/
    
    this.dp.forEach((item, index, arr)=>{
      arr[index].discount_header_perc = discount_header_perc;
      this._calculatePrice(index);
      this.calculateTotal(arr[index].id);
    });
    let index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
    console.log(`update the current item: ${index}`);
    ['discount','price','count','price_w_tax','discount_perc'].forEach((key)=>{
      this.inv_model[key] = this.dp[index][key] ;
    });
    // this.inv_model['discount'] = (Number(this.inv_model['discount']) / Number(this.dp[index]['count'])).toFixed(2); 
  }

  changeTax(event) {
    let id = event.srcElement.id;
    this.inv_model['tax_no'] = event.srcElement.value;
    console.log(this.inv_model['tax_no']);

    let tax_perc = 0, tax_amnt = 0;
    if (this.inv_model['tax_no'] != '0') {
      for (let indx = 1; indx < this.taxList.length; indx++) {
        let element = this.taxList[indx];
        if (element.acct_number == this.inv_model['tax_no']) {
          if (element.tax_perc != 0)
            tax_perc = element.tax_perc;
          else if (element.tax_amount != 0)
            tax_amnt = element.tax_amount;
        }
      }
    }
    
    let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
    this.dp[dp_index]['tax_no'] = this.inv_model['tax_no'];
    this.dp[dp_index]['tax_perc'] = tax_perc;
    this.dp[dp_index]['tax_amnt'] = tax_amnt;

    this.calculateTotal(this.inv_model['id']);

    let taxObj = this.getTax(this.inv_model.tax_no);
    this.inv_model['price_w_tax'] = (Number(this.inv_model['price']) * (1 + taxObj.tax_perc)).toFixed(2);
  }

  changeDiscount(event) {
    // let id = event.srcElement.id;
    let discount = Number(event.srcElement.value);
    
    if (isNaN(discount)) {
      this.inv_model['discount'] = String(event.srcElement.value);
      (document.getElementById('discount') as HTMLInputElement).value = this.inv_model['discount'];
    }

    // if (isNaN(discount)) {
    //   this.inv_model['discount'] = '0';
    //   (document.getElementById('discount') as HTMLInputElement).value = '0';
    // }

    if (!isNaN(discount)) {
      console.log("D: " + discount);
      // let dp_index = this.getDPIndex(this.inv_model['id']);
      let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
      this.dp[dp_index]['discount'] = this.inv_model['discount'];
      this.dp[dp_index]['has_discount_value'] = '1';
      this.dp[dp_index]['discount_perc'] = '0'; 
      (document.getElementById('item_discount_perc') as HTMLInputElement).value = this.dp[dp_index]['discount_perc'];
      
      console.log("Discount: " + this.dp[dp_index]['discount']);
      this.calculateTotal(this.inv_model['id']);

      // let taxObj = this.getTax(this.dp[dp_index].tax_no);
      // let total_price = Number(this.inv_model['price']) * Number(this.inv_model['count']);
      // // let priceWTax = Number(this.inv_model['price_w_tax']);
      // let discount = Number(this.dp[dp_index]['discount']);
      // let taxAmount, discount_perc;

      // if (taxObj.tax_perc > 0) {
      //   taxAmount = (total_price - discount) * taxObj.tax_perc;
      // }
      // else {
      //   taxAmount = taxObj.tax_amnt;
      // }
      // console.log("TaxAmount: " + taxAmount);
      // if (priceWTax > 0) {
      //   if (taxObj.tax_perc > 0) {
      //     price = priceWTax / (1 + taxObj.tax_perc) + discount;
      //     taxAmount = priceWTax - (priceWTax / (1 + taxObj.tax_perc));
      //   }
      //   else {
      //     price = priceWTax - taxObj.tax_amnt + discount;
      //     taxAmount = taxObj.tax_amnt;
      //   }
      // }
      // else if (price > 0) {
      //   if (taxObj.tax_perc > 0) {
      //     priceWTax = (price - discount) + ((price - discount) * taxObj.tax_perc);
      //     taxAmount = (price - discount) * taxObj.tax_perc;
      //   }
      //   else {
      //     priceWTax = (price - discount) + taxAmount;
      //     taxAmount = taxObj.tax_amnt;
      //   }
      // }
        
      // this.inv_model['price'] = price.toFixed(2);
      // (document.getElementById('price') as HTMLInputElement).value = price.toFixed(2);

      // this.inv_model['price_w_tax'] = ''; // priceWTax.toFixed(2);
      // (document.getElementById('price_w_tax') as HTMLInputElement).value = ''; // priceWTax.toFixed(2);
      
      // this.inv_model['discount'] =  discount.toFixed(2);

      // // discount_perc = (discount * 100) / price;
      // this.inv_model['discount_perc'] = ''; // discount_perc.toFixed(2);
      // (document.getElementById('item_discount_perc') as HTMLInputElement).value = ''; // discount_perc.toFixed(2);

      // // this.dp[dp_index]['price'] = price.toFixed(2);
      // this.dp[dp_index]['price_w_tax'] = ''; // price.toFixed(2);  
      // this.dp[dp_index]['tax_amount'] = taxAmount.toFixed(2);
      // this.dp[dp_index]['net_total_price'] = (total_price - discount + taxAmount).toFixed(2);
      // console.log("net_total_price: " + this.dp[dp_index]['net_total_price']);
      // this.dp[dp_index]['discount_perc'] = ''; // discount_perc.toFixed(2);

      // console.log(this.dp[dp_index]);
      // this.calculateTotal(this.inv_model['id']);
    }
  }

  changeInstallPerc(event) {
    let id = event.srcElement.id;

    if (isNaN(Number(event.srcElement.value))) {
      this.inv_model['install_perc'] = String(parseFloat(event.srcElement.value));
      (document.getElementById('install_perc') as HTMLInputElement).value = this.inv_model['install_perc'];
    }

    if (isNaN(Number(event.srcElement.value))) {
      this.inv_model['install_perc'] = '0';
      (document.getElementById('install_perc') as HTMLInputElement).value = '0';
    }

    if (!isNaN(Number(event.srcElement.value))) {
      // let dp_index = this.getDPIndex(this.inv_model['id']);
      let dp_index = this.utils.getDPIndex(this.dp, 'id', this.inv_model['id']);
      this.dp[dp_index]['install_perc'] = this.inv_model['install_perc'];
      console.log('install_perc: ' + this.inv_model['install_perc']);
      this.calculateTotal(this.inv_model['id']);
    }
  }

  editSubItem(row) {

    let tr_input = document.getElementById('tr_input') as HTMLSourceElement;
    // let tr_input_2 = document.getElementById('tr_input_2') as HTMLSourceElement;
    tr_input.style.background = "#fd88ab";
    // tr_input_2.style.background = "#fd88ab";
    setTimeout(() => {
      tr_input.style.background = "transparent";
      // tr_input_2.style.background = "transparent";
    }, 3000);

    console.log(row);
    console.log(this.dp);
    let sub_item_name = '';
    let sub_item_name_en = '';
    
    this.sub_item_unit = row.sub_item_unit;

    this.inv_model['sub_item_no'] = row.sub_item_no;

    if (row.sub_item_name != undefined)
      sub_item_name = row.sub_item_name;
    if (row.sub_item_name_en != undefined)
      sub_item_name_en = row.sub_item_name_en;

    (document.getElementById('search_value_10') as HTMLInputElement).value = row.sub_item_no + "-" +
      sub_item_name; // + '-' + sub_item_name_en;
    // (document.getElementById('search_value_2') as HTMLInputElement).value = sub_item_name_en;

    if (this.model.invoice_type != 'advanced' && this.model.invoice_type != 'install' && this.model.invoice_type != 'qty_install')
      (document.getElementById('price') as HTMLInputElement).disabled = (row.price_flex != '1');

    if (this.model.invoice_type == 'qty_install')
      (document.getElementById('count') as HTMLInputElement).disabled = false;

    this.inv_model['avail_amount'] = row.available_count;
    this.inv_model['unit_no'] = row.unit_no;
    this.inv_model['count'] = row.count;
    this.inv_model['price'] = row.price;
    this.inv_model['discount'] = row.discount;
    this.inv_model['install_perc'] = row.install_perc;
    this.inv_model['net_price'] = row.net_price;
    this.inv_model['sub_item_number'] = row.sub_item_number;
    this.inv_model['tax_no'] = row.tax_no;
    this.inv_model['total_price'] = row.total_price;
    this.inv_model['tax_amount'] = row.tax_amount;
    this.inv_model['comment'] = row.comment;
    this.inv_model['id'] = row.id;

    ['discount','price','count','price_w_tax','discount_perc','tax_no','tax_amount'].forEach((key)=>{
      this.inv_model[key] = row[key];
    });
    // this.inv_model['discount'] = (Number(this.inv_model['discount']) / Number(row.count)).toFixed(2)
  }

  delSubItem(row_id) {
    (document.getElementById('chx_del_' + row_id) as HTMLInputElement).checked = true;
    this.delLine();
  }

  addComment(row) {
    let dialog_data = row;
    console.log(row);
    this.commentDialogRef = this.dialog.open(InvoiceItemCommentComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.commentDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') { 
          //console.log(result);
          let dp_index = this.utils.getDPIndex(this.dp, 'id', row.id);   // this.inv_model['id']
          this.dp[dp_index]['comment'] = result['comment'];
          //console.log(this.dp[dp_index]);
        }
      });
  }

}